<template>
    <injury-donut :docs="docs" field="type" :colors="colors" :label-fn="injuryTypeLabel"
        :center-label="$t('statistics.distinct_types')" />
</template>

<script>
import InjuryDonut from './InjuryDonut.vue'

export default {
    name: 'InjuryTypeChart',
    components: { InjuryDonut },
    props: {
        docs: {
            type: Array,
            default: null,
        }
    },
    data() {
        return {
            colors: [
                '#009966', '#339999', '#66CCCC', 'rgba(204,255,51,0.75)', '#66cc99',
            ],
        }
    },
}
</script>
